"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._AddSmartValidationToIBAN = _AddSmartValidationToIBAN;
// iban.ts
var translation_1 = __importDefault(require("@src/services/translation"));
var error_helper_const_1 = require("../error-handling/error-helper.const");
var validate_iban_1 = require("./validate-iban"); // <-- adjust path
function _AddSmartValidationToIBAN(input, opts) {
    var _a;
    if (opts === void 0) { opts = {}; }
    var showStatus = (_a = opts.showStatus) !== null && _a !== void 0 ? _a : true;
    if (input.__ibanAttached)
        return;
    input.__ibanAttached = true;
    var tr = function (key) { return translation_1.default.t(key); };
    var host = function () { return input === null || input === void 0 ? void 0 : input[0]; };
    var countAlnum = function (s) { return (0, validate_iban_1.ibanToElectronic)(s).length; };
    var mapCountToIndex = function (friendly, targetCount) {
        if (!Number.isFinite(targetCount) || targetCount <= 0)
            return 0;
        var seen = 0;
        for (var i = 0; i < friendly.length; i++) {
            if (/[A-Z0-9]/.test(friendly[i]))
                seen++;
            if (seen >= targetCount)
                return i + 1;
        }
        return friendly.length;
    };
    // ---------------------------
    // Status element (no inline styling)
    // ---------------------------
    var getStatusEl = function () {
        if (!showStatus)
            return null;
        var h = host();
        if (!h)
            return null;
        var cached = input.__ibanStatusEl;
        if (cached && cached.isConnected)
            return cached;
        var next = h.nextElementSibling;
        if (next && next.getAttribute('data-iban-status') === '1') {
            input.__ibanStatusEl = next;
            return next;
        }
        var div = document.createElement('div');
        div.setAttribute('data-iban-status', '1');
        h.insertAdjacentElement('afterend', div);
        input.__ibanStatusEl = div;
        return div;
    };
    var setStatus = function (text) {
        var s = getStatusEl();
        if (!s)
            return;
        s.textContent = text;
        s.style.display = text ? '' : 'none';
    };
    var clearAllStatus = function () {
        input.__ibanLastError = '';
        (0, error_helper_const_1._RemoveStatusFromDomObject)(input);
        setStatus('');
    };
    var setInvalid = function (msgKey, strict) {
        clearAllStatus();
        if (!strict)
            return;
        var msg = tr(msgKey);
        var last = input.__ibanLastError;
        if (last === msg)
            return;
        input.__ibanLastError = msg;
        (0, error_helper_const_1._AddErrorToDomObject)(input, msg);
    };
    var setSuccess = function (msgKey) {
        clearAllStatus();
        (0, error_helper_const_1._AddSuccessToDomObject)(input, tr(msgKey));
    };
    var update = function (strict) {
        var _a, _b, _c, _d;
        var h = host();
        if (!h)
            return;
        var before = (_a = h.value) !== null && _a !== void 0 ? _a : '';
        // preserve selection while rewriting spaces
        var selStart = (_b = h.selectionStart) !== null && _b !== void 0 ? _b : before.length;
        var selEnd = (_c = h.selectionEnd) !== null && _c !== void 0 ? _c : before.length;
        var startCount = countAlnum(before.slice(0, selStart));
        var endCount = countAlnum(before.slice(0, selEnd));
        // ---- PURE validation call (does electronic+friendly) ----
        var res = (0, validate_iban_1.validateIbanValue)(before);
        // apply formatting
        if (h.value !== res.friendly) {
            h.value = res.friendly;
            h.setSelectionRange(mapCountToIndex(res.friendly, startCount), mapCountToIndex(res.friendly, endCount));
        }
        (_d = opts.onElectronicChange) === null || _d === void 0 ? void 0 : _d.call(opts, res.electronic);
        // ---- UI behavior based on validation result ----
        switch (res.state) {
            case 'empty':
                clearAllStatus();
                setStatus(tr(res.hintKey));
                return;
            case 'hint':
                clearAllStatus();
                setStatus(tr(res.hintKey));
                return;
            case 'progress':
                clearAllStatus();
                setStatus("".concat(res.cc, ": ").concat(res.current, "/").concat(res.expected, " ").concat(tr('IBAN_CHARS')));
                return;
            case 'valid':
                setSuccess('IBAN_VALID');
                return;
            case 'invalid':
                // preserve old behavior: checksum invalid always shows error immediately
                setInvalid(res.errorKey, strict || !!res.alwaysError);
                return;
        }
    };
    input.on('input', function () { return update(false); });
    input.on('blur', function () { return update(true); });
    input.on('change', function () { return update(true); });
    update(false);
}
